import React from "react";
import messageImg from "assets/images/message.svg";
import whatsappImg from "assets/images/whatsapp.svg";
import "./LoginAppsDownload.scoped.scss";
import * as TagManager from "core/common/seo/tagManager";
import MobileSystem from "core/common/types/MobileSystem"


const LoginAppsDownload = () => {
  return (
    <React.Fragment>
      <div
        style={{margin: "0 auto" }}
        className="apps-download"
      >
        <h3>האפליקציה לשירותכם:</h3>
        <ul className="apps-download-list">
          <li>
            <a href={MobileSystem.IOS.url}>
              <img src={MobileSystem.IOS.img} alt="appleStore" />
            </a>
          </li>
          <li>
            <a href={MobileSystem.Android.url}>
              <img src={MobileSystem.Android.img} alt="googlePlay" />
            </a>
          </li>
        </ul>
      </div>
    </React.Fragment>
  );
};

// const WhatappButtonClicked = () => {
//   TagManager.sendGoogleEvent({
//     category: `password login page`,
//     action: "click on WhatsApp link",
//     label: "click",
//   });
// };

// const EmailTextClicked = () => {
//   TagManager.sendGoogleEvent({
//     category: `password login page`,
//     action: "click on contact via email",
//     label: "click",
//   });
// };

export default LoginAppsDownload;
